const steps = [
  {
    number: '01',
    icon: 'ri-search-eye-line',
    title: 'Discovery Call',
    description:
      'We start with a focused conversation to understand your business, challenges, and goals. No fluff — just a candid assessment of where you are and where you want to go.',
  },
  {
    number: '02',
    icon: 'ri-file-list-3-line',
    title: 'Strategic Assessment',
    description:
      'Our team conducts a deep-dive analysis of your operations, financials, and market position to identify the highest-leverage opportunities for growth and improvement.',
  },
  {
    number: '03',
    icon: 'ri-lightbulb-flash-line',
    title: 'Custom Roadmap',
    description:
      'We deliver a tailored action plan with clear priorities, timelines, and measurable milestones — built specifically around your business model and objectives.',
  },
  {
    number: '04',
    icon: 'ri-rocket-2-line',
    title: 'Execution & Support',
    description:
      'We work alongside your leadership team to implement the strategy, drive accountability, and adapt in real time to ensure results are achieved.',
  },
  {
    number: '05',
    icon: 'ri-line-chart-line',
    title: 'Measure & Optimize',
    description:
      'We track KPIs, review outcomes, and continuously refine the approach — ensuring every initiative delivers maximum impact and lasting value.',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 px-6 bg-texas-navy">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-texas-red text-xs font-bold tracking-widest uppercase mb-3 block">Our Process</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
            How It Works
          </h2>
          <p className="text-white/60 text-base max-w-xl mx-auto">
            A proven five-step engagement process designed to deliver clarity, momentum, and measurable results from day one.
          </p>
        </div>

        <div className="relative">
          {/* Connector line — desktop only */}
          <div className="hidden lg:block absolute top-[52px] left-[calc(10%+28px)] right-[calc(10%+28px)] h-px bg-white/10" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-4">
            {steps.map((step, idx) => (
              <div key={step.number} className="flex flex-col items-center text-center relative">
                <div className="relative mb-5">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-texas-red text-white z-10 relative">
                    <i className={`${step.icon} text-2xl`} />
                  </div>
                  <span className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center rounded-full bg-white text-texas-navy text-[10px] font-bold leading-none">
                    {idx + 1}
                  </span>
                </div>

                <span className="text-xs font-bold text-white/30 tracking-widest mb-1 uppercase">
                  Step {step.number}
                </span>

                <h4 className="text-sm font-bold text-white mb-2 leading-snug">
                  {step.title}
                </h4>
                <p className="text-xs text-white/55 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-14">
          <a
            href="#contact"
            className="inline-block bg-texas-red hover:bg-texas-red-dark text-white text-sm font-semibold px-8 py-3 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Start Your Discovery Call
          </a>
        </div>
      </div>
    </section>
  );
}
